// services/auth.js
// eslint-disable-next-line import/named
import {http, setToken, setRefreshToken, getToken, removeToken, getRefreshToken} from './request';
import {success} from '../toast';

export const getUser = () => {
    const userStr = localStorage.getItem('userInfo');
    return userStr ? JSON.parse(userStr) : null;
};
export const setUser = user => localStorage.setItem('userInfo', JSON.stringify(user));
export const removeUser = () => localStorage.removeItem('userInfo');

export const auth = {
    login: async (phone, code) => {
        const data = await http.post('/phoneLogin', {phone, code, tenantId: http.tenantId});
        if (data.success) {
            const {accessToken, refreshToken} = data.result;
            setToken(accessToken);
            setRefreshToken(refreshToken);
            const res = await http.get('/user-info');
            if (res.success) {
                success('登录成功！');
                setUser(res.result);
            }
            return data.result;
        }
        return null;
    },
    loginPoll: async sceneId => {
        const data = await http.get('/loginPoll', {sceneId});
        if (data.success) {
            const {accessToken, refreshToken} = data.result;
            setToken(accessToken);
            setRefreshToken(refreshToken);
            const res = await http.get('/user-info');
            if (res.success) {
                success('登录成功！');
                setUser(res.result);
            }
            return data.result;
        }
        return null;
    },
    logout: () => {
        removeToken();
        removeUser();
        success('退出登录！');
    },
    getCurrentUser: async () => {
        const res = await http.get('/user-info');
        if (res.success) {
            setUser(res.result);
            return res.result;
        }
        return null;
    },
    isAuthenticated: () => {
        if (getToken() === null) {
            return false;
        }
        try {
            const token = getToken();
            const strings = token.split('.');
            const payload = strings[1] || '';
            const decodedPayload = window.atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
            const userInfo = JSON.parse(decodeURIComponent(escape(decodedPayload)));
            const ts = Math.floor(Date.now() / 1000);
            return !(userInfo.exp < ts && getRefreshToken() === null);
        } catch (e) {
            return false;
        }
    },
    hasRole: roleName => {
        const user = getUser();
        return Boolean(user && Array.isArray(user.roles) && user.roles.includes(roleName));
    },
    hasPermission: perm => {
        const user = getUser();
        return Boolean(user && Array.isArray(user.permissions) && user.permissions.includes(perm));
    },
    getAvatar: () => {
        const user = getUser();
        const avatar = user && user.avatar;
        if (!avatar) return null;
        if (/^(data:|blob:|https?:)/.test(avatar)) return avatar;
        return `${http.domain}${avatar}`;
    },
    getNickname: () => {
        const user = getUser();
        return user && user.nickname ? user.nickname : '';
    }
};
